var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-error"},[_c('vue-headful',{attrs:{"title":_vm.$PPlusEngine.getDictionary(_vm.$route.params.lang, 
            'Page Not Found - ProbPlus', 
            'Page Not Found - ProbPlus'),"description":_vm.$PPlusEngine.getDictionary(_vm.$route.params.lang, 
            '',
            '')}}),_c('div',{staticClass:"message"},[_c('img',{attrs:{"src":require("@/assets/error.png")}}),_c('h1',[_vm._v("Page Not Found")]),_c('span',[_vm._v("Sorry, the page you are looking for was not found in our website")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }